module.exports = __webpack_public_path__ + "img/icon2.edb33220.png";